export class Verify {
    /** Verification of form fields */
    static email(address: string) { return !!(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(address)) }

    static state(code: string) { return !!(code.length === 2) }
}